export const ALERT_DYNAMIC_COLUMN_IDS = {
	AdditionalText: 'additional_text'
};
